'use client';
import { useState } from 'react';
import { usePathname } from 'next/navigation';
import { IconMessageReportFilled } from '@tabler/icons-react';
import { SupportTicketModal } from './SupportTicketModal';

export const SupportButton = () => {
  const [showSupportModal, setShowSupportModal] = useState<boolean>(false);
  const pathname = usePathname();

  return (
    <>
      <button
        onClick={() => setShowSupportModal(true)}
        className="px-4 py-3 rounded-[100px] bg-white/75 hover:bg-white transition-colors flex items-center justify-center"
        title="Submit Support Ticket"
      >
        <IconMessageReportFilled size={24} className="text-primary-600" />
      </button>
      <SupportTicketModal
        isOpen={showSupportModal}
        onClose={() => setShowSupportModal(false)}
        currentLocation={pathname}
      />
    </>
  );
};
